import { toast } from "react-toastify";

import { apiClient } from "../../../api/httpClient";
import { buildEndorsementFormData } from "../../Law Firm User/helpers/lawFirmBondsHelpers";

/**
 * POST endorsement (shared by law-firm dialogs, approve-bonds, archives).
 * Payload shape must match {@link buildEndorsementFormData}.
 */
export async function postEndorsementFormData({
  payload,
  setSubmitting,
  onSuccess,
  successMessage = "Bond endorsed successfully!",
}) {
  const bondId = payload?.selectedBondToEndorse?.bond_id;
  if (!bondId) return;

  setSubmitting?.(true);
  try {
    const formData = buildEndorsementFormData(payload);
    await apiClient(
      `/endorse-bond/`,
      "POST",
      formData,
      { bond_id: bondId },
      { "Content-Type": "multipart/form-data" }
    );
    toast.success(successMessage);
    await onSuccess?.();
  } catch (error) {
    console.error("Endorsement failed:", error);
    toast.error(error.message || "Failed to endorse the bond.");
  } finally {
    setSubmitting?.(false);
  }
}
